import store from '@/store';
import { Route } from 'vue-router';
import { NavigationGuardNext } from 'vue-router/types/router';
import { RouteName } from '@/router/types';

export function settingsIntegrationsGuard(to: Route, from: Route, next: NavigationGuardNext): boolean {
  if (!store.getters['tenant/isIntegrationsEnabled']) {
    next({ name: RouteName.Settings });
  } else {
    next();
  }
  return true;
}
